export default __webpack_public_path__ + "static/media/Book6.57b380e6.pdf";